import { SxProps, Theme } from '@mui/material';

// --- Color helpers ---

/**
 * Returns MUI color token for DEE status.
 * 1=default, 2/3/5=in progress, 6=concluded
 */
export const getDeeStatusColor = (status: number): string => {
    switch (status) {
        case 2:
        case 3:
        case 5:
            return 'warning.main';
        case 6:
            return 'success.main';
        default:
            return 'grey.300';
    }
};

/**
 * Returns MUI color token based on value vs threshold.
 */
export const getGradeColor = (value: number, threshold: number): string => {
    return value >= threshold ? 'success.main' : 'grey.300';
};

/**
 * Returns contrasting text color for a given background color token.
 * White text for colored backgrounds, default for grey.
 */
export const getContrastText = (bgColor: string): string => {
    return bgColor === 'grey.300' ? 'text.primary' : '#fff';
};

// --- Shared sx styles ---

export const sharedStyles = {
    containerRow: {
        display: 'flex',
        alignContent: 'flex-start',
        flexDirection: 'row',
        flexWrap: 'wrap',
    } as const,

    containerRowNoWrap: {
        display: 'flex',
        alignContent: 'flex-start',
        flexDirection: 'row',
        flexWrap: 'nowrap',
    } as const,

    tooltipGrid: {
        display: 'flex',
        alignContent: 'flex-start',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        margin: '3px',
    } as const,

    moduleCard: {
        display: 'flex',
        alignContent: 'flex-start',
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderWidth: '0px',
        borderStyle: 'solid',
        borderRadius: '10px',
        backgroundColor: 'grey.100',
        border: 1,
        borderColor: 'divider',
        '&:hover': {
            boxShadow: 1,
        },
    } as const,

    accordionSummary: {
        backgroundColor: 'grey.300',
        '&:hover': {
            backgroundColor: 'grey.400',
        },
    } as const,

    fieldGrid: {
        display: 'flex',
        alignContent: 'flex-start',
        flexDirection: 'row',
        flexWrap: 'wrap',
        mb: 1,
        p: 1,
    } as const,

    disabledFieldset: {
        backgroundColor: 'action.disabledBackground',
        border: 'none',
        padding: 0,
        width: '100%',
    } as const,
};
